export { getServerSideProps } from '~/components/pages/SearchResults/serverSideProps/getServerSideProps';
export { SearchResults as default } from '~/components/pages/SearchResults/SearchResults';
